<span class="step-content">
    <table class="table">
        <tbody>
            <ng-container *ngFor="let block of step?.blocks | slice:isCollapsedIndex[0]:isCollapsedIndex[1]; let i = index">
                <ng-container *ngIf="block.type !== stepTypeEnum.Menu">
                    <a class="step step-link" [routerLink]="getRoutingLink(block)" [ngClass]="{'inactive-link': block.enabled, 'gradient-overlay': isCollapsed && step && step.blocks && step.blocks.length > 3 && i === 2}" >
                        <tr class="block-info">

                            <!--Блок с галочкой, замком, флажклм слева -->
                            <th class="block-column-icon">
                                <ng-container *ngIf="!block.progress?.mastered && (block.showLock || block.parent?.showLock)">
                                    <mat-icon class="block-icon unshrinkable" svgIcon="lock-closed"></mat-icon>
                                </ng-container>
                                <ng-container *ngIf="block.showFlag && !(block.showLock || block.parent?.showLock)">
                                    <ng-container *ngIf="block.passed">
                                        <mat-icon class="success-mark-icon" svgIcon="passed" [ngClass]="{'success-mark-icon-locked': block.showLock || block.parent?.showLock}"></mat-icon>
                                    </ng-container>
                                    <ng-container *ngIf="!block.passed">
                                        <mat-icon class="success-mark-icon primary-icon" svgIcon="not-passed" [ngClass]="{'success-mark-icon-locked': block.showLock || block.parent?.showLock}"></mat-icon>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="block?.progress && block.progress?.type === progressTypeEnum.FACT">
                                    <mat-icon class="success-mark-icon" svgIcon="success-mark-paracelsus" [ngClass]="{
                                        'success-mark-icon-locked': block.showLock || block.parent?.showLock,}"></mat-icon>
                                </ng-container>
                            </th>
                            <!--Блок с текстом -->
                            <th class="block-column-text">
                                <div style="margin-right: .5rem;">
                                    <p class="column-paragraph"
                                    [ngClass]="{
                                        'inactive-text': block?.enabled,
                                        'locked-text': block.showLock || block.parent?.showLock,
                                    }"
                                    class="block-title mat-body-1">{{block?.name}}</p>
                                    <p *ngIf="block?.passed !== null" style="margin: 0;"
                                    class="step-info-text"
                                    [ngClass]="{
                                            'inactive-text': block?.enabled,
                                            'success-text': !block?.enabled && block?.passed,
                                            'alert-text': !block?.enabled && !block?.passed,
                                            'locked-text': block.showLock || block.parent?.showLock,
                                    }"
                                    >{{block?.passed ? 'Зачтено!' : 'Не зачтено'}}</p>
                                    <p *ngIf="block?.progress?.mandatoryOption"
                                    class="step-info-text"
                                    [ngClass]="{
                                        'inactive-text': block?.enabled || block?.passed || block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.OPTIONAL,
                                        'success-text': !block?.enabled && block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.RECOMMENDED,
                                        'alert-text': !block?.enabled &&  block?.progress?.mandatoryOption === mandatoryMasteredOptionEnum.REQUIRED,
                                        'locked-text': block.showLock || block.parent?.showLock,

                                    }">{{getMandatoryOptionText(block)}}</p>
                                </div>
                            </th>
                            <!--Блок с освоением справа -->
                            <th class="block-column-icon ordinary-text" style="margin-left: auto;">
                                <!--FACT -->
                                <ng-container *ngIf="block.progress && block.progress?.type === progressTypeEnum.FACT && !(block.showLock || block.parent?.showLock)">
                                    <ng-container *ngIf="block.progress?.mastered == true">
                                        <div class="icon-fact-container">
                                            <mat-icon class="success-mark-icon-step" svgIcon="fact-green-unfilled"></mat-icon>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="block.progress?.mastered == false">
                                        <div class="icon-fact-container">
                                            <mat-icon class="success-mark-icon-step" svgIcon="fact-red-unfilled"></mat-icon>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <!--SCALE -->
                                <ng-container *ngIf="block.progress && block.progress?.type === progressTypeEnum.SCALE && !(block.showLock || block.parent?.showLock)">
                                <ng-container *ngIf="deviceType === 'mobile'">
                                    <app-progress-spinner
                                    class="spinner-value-text"
                                    [color]="'var(--spiner-color-blue)'"
                                    [backgroundColor]="'var(--spiner-color-red)'"
                                    [value]="block.progress.value"
                                    [diametr]="30"
                                    [strokeWidth]="4"
                                    ></app-progress-spinner>
                                    </ng-container>
                                    <ng-container *ngIf="deviceType !== 'mobile'">
                                    <app-progress-spinner
                                    class="spinner-value-text"
                                    [color]="'var(--spiner-color-blue)'"
                                    [backgroundColor]="'var(--spiner-color-red)'"
                                    [value]="block.progress.value"
                                    [diametr]="50"
                                    [strokeWidth]="6"
                                    ></app-progress-spinner>
                                    </ng-container>
                                </ng-container>
                            </th>
                        </tr>
                    </a>
                </ng-container>
            </ng-container>
        </tbody>
    </table>
</span>

<ng-container *ngIf="step && step.blocks && step.blocks.length > 3">
    <div class="toggle-container"
        (mousedown)="isPressed = true"
        (mouseup)="isPressed = false"
        (mouseleave)="isPressed = false"
         (click)="toggle()">

       <div class="toggle-top">
           <div class="toggle-top-left"></div>
           <div class="toggle-top-middle"></div>
           <div class="toggle-top-right"></div>
       </div>

       <div class="toggle-bottom">
           <div class="toggle-bottom-top">
               <img src="assets/icons/hide_expand.svg"
                class="icon"
                [ngClass]="{'shadow-effect': isPressed}"
                [class.rotated]="!isCollapsed"
                [ngStyle]="{ 'margin-bottom': !isCollapsed ? '10px' : '5px' }">
           </div>
           <div class="toggle-bottom-bottom"></div>
       </div>
    </div>
</ng-container>

